import {
  checkPasswordRules,
  PASSWORD_DISPLAY_RULE_IDS,
  type PasswordDisplayRuleId,
} from '../lib/password';
import { useLanguage } from '../lib/i18n/LanguageContext';

type PasswordValidationRulesProps = {
  password: string;
  /** When false, nothing is rendered until the user starts typing. */
  visible?: boolean;
  id?: string;
};

function RuleIcon({ met }: { met: boolean }) {
  return (
    <span className={`password-rule-icon${met ? ' password-rule-icon--met' : ''}`} aria-hidden="true">
      {met ? '✓' : '×'}
    </span>
  );
}

export function PasswordValidationRules({ password, visible = true, id }: PasswordValidationRulesProps) {
  const { dict } = useLanguage();
  if (!visible || password === '') return null;

  const rules = checkPasswordRules(password);
  const labels: Record<PasswordDisplayRuleId, string> = dict.passwordValidation;

  return (
    <ul className="password-rules" id={id} aria-live="polite">
      {PASSWORD_DISPLAY_RULE_IDS.map((ruleId) => {
        const met = rules[ruleId];
        return (
          <li
            key={ruleId}
            className={`password-rule${met ? ' password-rule--met' : ' password-rule--unmet'}`}
          >
            <RuleIcon met={met} />
            <span>{labels[ruleId]}</span>
          </li>
        );
      })}
    </ul>
  );
}
